export var TEALIUM_PAGE_VIEW = {
  PAGE_L1: 'MLP',
  PAGE_L2: 'Dental Provider',
  PAGE_L3: {
    REGISTRATION: 'registration',
    HOME: 'home',
    MEMBER_SEARCH: 'member search',
    BENEFIT_DETAILS: 'benefit details',
    PROFILE: 'profile',
    NETWORK_SEARCH: 'network search',
    CLAIMS: 'claims'
  },
  PAGE_L4: {
    REGISTRATION: {
      IDENTITY_VERIFICATION: 'Identity Verification',
      ADDITIONAL_INFORMATION: 'Additional Information',
      VERIFY_EMAIL: 'Verify Email'
    },
    HOME: {
      LOGIN: 'login'
    },
    MEMBER_SEARCH: {
      SEARCH: 'Search'
    },
    BENEFIT_DETAILS: {
      SEARCH: 'Search'
    },
    PROFILE: {
      PROFILE_INFORMATION: 'profile information'
    },
    NETWORK_SEARCH: {
      SEARCH: 'Search'
    },
    CLAIMS: {
      SEARCH: 'Search'
    }
  }
};
export var TEALIUM_EVENT = {
  EVENT_ACTION: {
    BLUR: 'blur',
    FOCUS: 'focus',
    ERROR: 'error',
    BUTTON: 'button',
    LINK: 'link'
  },
  EVENT_TYPE: {
    FOOTER: 'footer',
    REGISTRATION: 'registration',
    LOGIN: 'login',
    LOGOUT: 'logout',
    FORGOT_PASSWORD: 'forgotPassword',
    SEARCH: 'search',
    BENEFIT_DETAILS: 'benefit details',
    CONTACT_SUPPORT: 'contact&support',
    HOME: 'home',
    PROC_CODE_SEARCH: 'procedure code search',
    PROFILE: 'profile',
    PROFILE_BASIC_INFO: 'profile - basic info',
    PROFILE_EMAIL: 'profile - email',
    PROFILE_PASSWORD: 'profile - password',
    MM_LINK: 'mmlink',
    H_LINK: 'hlink',
    WELCOME_OVERLAY: 'welcome overlay',
    MULTIPLE_SUB_MODAL: 'multiple subscriber modal',
    MULTIPLE_CLAIMS_MODAL: 'multiple claims modal',
    TREATMENT_HISTORY_SEARCH: 'treatment history search',
    NETWORK_SEARCH: 'network search',
    CLAIMS: 'claims',
    CLAIMS_SEARCH: 'claims search',
    PRECERTIFICATION_SEARCH: 'precertification search',
    HELP_CENTER: 'help center'
  },
  EVENT_STATUS: {
    START: 'Start',
    CANCEL: 'Cancelled',
    COMPLETE: 'Complete',
    SUCCESSFUL_LOGIN: 'Logged In',
    SUBMITTED: 'Submitted'
  }
};